import Swiper, { Autoplay, EffectCreative, Navigation, Pagination, Grid } from "swiper";

document.addEventListener("DOMContentLoaded", () => {
  const quizes = document.querySelectorAll(".quiz");

  quizes.forEach((quiz) => {
    let quizSlider = new Swiper(quiz.querySelector(".quiz__slider"), {
      modules: [Navigation, Autoplay, EffectCreative, Pagination, Grid],
      slideClass: "quiz__slide",
      pagination: {
        el: quiz.querySelector(".swiper-pagination"),
        clickable: true,
        bulletClass: "quiz__pagination pagination__item",
        bulletActiveClass: "pagination__item--active",
      },
      navigation: {
        nextEl: ".quiz__nav-btn-next",
        prevEl: ".quiz__nav-btn-prev",
      },
    });

    const answersBlock = quiz.querySelectorAll(".answer-block__answers-block");

    const showAnswersBlock = (el) => {
      answersBlock.forEach((block) => {
        if (el == block) {
          block.classList.add("shown");
        } else {
          block.classList.remove("shown");
        }
      });
    };

    answersBlock.forEach((block) => {
      const answersBtn = block.querySelectorAll(".answer-block__btn");

      const clickAnswerBtnHandler = (btn) => {
        const answersBlock = btn.closest(".answer-block__answers-block");
        answersBlock.classList.add("result-shown");
        const dataPercent = btn.dataset.percent;
        const siblingBtn = btn.previousElementSibling || btn.nextElementSibling;
        const siblingDataPercent = siblingBtn.dataset.percent;
        btn.textContent = dataPercent + "% " + btn.textContent;
        siblingBtn.textContent = siblingDataPercent + "% " + siblingBtn.textContent;
        if (siblingBtn) {
          if (dataPercent > 50) {
            btn.classList.add("major");
          } else {
            siblingBtn.classList.add("major");
          }
        }
        answersBtn.forEach((btn) => {
          btn.removeEventListener("click", handler);
        });
      };

      const handler = (e) => {
        clickAnswerBtnHandler(e.target);
      };

      answersBtn.forEach((btn) => {
        btn.addEventListener("click", handler);
      });
    });

    showAnswersBlock(answersBlock[0]);
  });
});
